import { PERFORMS, CONTRIBUTES } from "@/assets/js/tactics/pitch/responsibilities";
import DefensivePressurePerformance from "./performances/central-attack/defensive-pressure";
import CreatingChancesPerformance from "./performances/central-attack/creating-chances";
import StretchingPlayPerformance from "./performances/central-attack/stretching-play";
import TakingChancesPerformance from "./performances/central-attack/taking-chances";


export default class CentralAttackResponsibilityPerformances {
  constructor() {
    this.defensivePressure = new DefensivePressurePerformance();
    this.creatingChances = new CreatingChancesPerformance();
    this.stretchingPlay = new StretchingPlayPerformance();
    this.takingChances = new TakingChancesPerformance();
  }

  countPerformance(performances) {
    for (const responsibility of Object.keys(performances)) {

      if (performances[responsibility].performs === PERFORMS) {
        this[responsibility].addPerformer(performances[responsibility].atypically);
        continue;
      }
      if (performances[responsibility].performs === CONTRIBUTES) {
        this[responsibility].addContributor(performances[responsibility].atypically);
      }
    }
  }
}
